(function (Drupal, $, once) {
    Drupal.behaviors.or17 = {
        attach(settings) {
            // Use once() t0 ensure that events are only bound once per page load
            $(once('or17', 'body'))
                .first()
                .each(function () {
                    const $megaNav = $('.OR17__mega-nav', );
                    const $actions = $megaNav.find('.OR17__header__actions');
                    const $body = $('body');
                    const openDuration = 1000;

                    function toggleMeganav() {
                        const megaNavOpened = $megaNav.hasClass(
                            'OR17__mega-nav--open',
                        );
                        // Hack to make the menu animation jump less visible.
                        megaNavOpened ? $actions.hide() : $actions.show();
                        // Accessibility: hide main content when nav is open.
                        if (megaNavOpened) {
                            $body.removeClass('OR17--opened');
                            $('.MO19__burger-menu').attr('title','Open main menu');
                            $('.MO19__burger-menu').attr('aria-label','Open main menu');
                            $('.MO19__burger-menu').attr('aria-pressed','true');
                            var tIndex = 0;
                        } else {
                            var tIndex = -1;
                            $('.OR17__close-button').attr('title','Close main menu');
                            $('.OR17__close-button').attr('aria-label','Close main menu');
                            $('.OR17__close-button').attr('aria-pressed','false');
                            setTimeout(() => {
                                if ($megaNav.hasClass('OR17__mega-nav--open')) {
                                    $body.addClass('OR17--opened');
                                }
                            }, openDuration);
                        }

                        const $logo = $('.MO19__logo');
                        $logo[0].tabIndex = tIndex;
                        const elements = $('.MO19__nav').children();
                        elements.each((el) => {
                            elements[el].tabIndex = tIndex;
                        });

                        $('.MO32 .js-form-submit')[0].tabIndex = tIndex;
                        $('.MO32 .form-item__textfield')[0].tabIndex = tIndex;

                        $megaNav.toggleClass('OR17__mega-nav--open');
                        $megaNav.toggleClass('OR17__mega-nav--close');
                        $megaNav.addClass('OR17__mega-nav--init');
                        $('body').toggleClass('no-scroll');
                        $('.MO27__nav', ).attr('data-current-level', 0);
                        $('.OR17__container', ).animate({
                            scrollTop: 0,
                        });
                    }

                    $('.MO19__burger-menu, .OR17__close-button', ).click(
                        function () {
                            toggleMeganav();
                            $('.MO19__burger-menu').attr(
                                'aria-expanded',
                                $('.MO19__burger-menu').attr(
                                    'aria-expanded',
                                ) !== 'true',
                            );
                        },
                    );

                    const searchAnimationDuration = 300;
                    const hiddenClass = 'hidden';
                    const $header = $('.OR17', ).first();
                    const $searchBar = $('.OR17__search-bar', ).first();
                    const $headerOverlap = $('.MO19', ).first();
                    const $searchTrigger = $('.MO19__search', ).first();

                    const searchPage = 'path-search';
                    const headerOpen = 'OR17--open';
                    const searchBarToggle = 'OR17__search-bar--open';
                    const headerClass = 'MO19--overlap';
                    const searchTriggerToggle = 'MO19__search--open';
                    const searchButton = $('.MO19__search');

                    function openSearchBar() {
                        if (!$('body').hasClass(searchPage)) {
                            $searchBar.removeClass(hiddenClass).outerWidth();
                            $header.addClass(headerOpen);
                            $headerOverlap.removeClass(headerClass);
                            $searchBar.addClass(searchBarToggle);
                            $searchTrigger.addClass(searchTriggerToggle);
                            $searchTrigger.attr('aria-expanded', 'true');
                            searchButton.attr('title','Close search');
                            searchButton.attr('aria-label','Close search');
                            searchButton.attr('aria-pressed','true');
                            $('input', $searchBar).first().focus();
                        }
                    }

                    function closeSearchBar() {
                        if (!$('body').hasClass(searchPage)) {
                            $header.removeClass(headerOpen);
                            $headerOverlap.addClass(headerClass);
                            $searchBar.removeClass(searchBarToggle);
                            $searchTrigger.removeClass(searchTriggerToggle);
                            $searchTrigger.attr('aria-expanded', 'false');
                            $searchBar
                                .removeClass(searchBarToggle)
                                .one('transitionend', function () {
                                    $searchBar.addClass(hiddenClass);
                                });
                            $searchTrigger.removeClass(searchTriggerToggle);
                            searchButton.attr('title','Search the ADMIRALTY site');
                            searchButton.attr('aria-label','Search the ADMIRALTY site');
                            searchButton.attr('aria-pressed','false');
                        }
                    }

                    $searchTrigger.click(function () {
                        if ($searchBar.hasClass(searchBarToggle)) {
                            closeSearchBar();
                        } else {
                            openSearchBar();
                        }
                    });

                    $('.OR17__search', ).click(function () {
                        toggleMeganav();
                        openSearchBar();
                    });


                    if ($header.offset()) {
                        const sticky = $header.offset().top;
                        window.onscroll = function () {
                            if (window.scrollY > sticky) {
                                $header.addClass('OR17--sticky');
                            } else {
                                $header.removeClass('OR17--sticky');
                            }
                        };
                    }
                });
        },
    };
})(Drupal, jQuery, once);
